import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rValue } from '../../models/.catalog';
import { rOyakKiraBilgileriUstBilgi } from '../../models/rOyakKiraBilgileriUstBilgi';

export default class OyakKiraBilgileriUstBilgiApi extends ApiBase<
  pList,
  rValue<rOyakKiraBilgileriUstBilgi>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakKiraBilgileriUstBilgi',
      }),
      options
    );
  }
}
